import React, { FC } from 'react';
import { Grid, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';

import { PaddedPaper } from 'components';

import Moderators from '../Moderators';

const useStyles = makeStyles(theme => ({
  paper: {
    padding: theme.spacing(4, 4, 5, 3),
  },
}));

const GroupManagers: FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <PaddedPaper square className={classes.paper}>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={3}>
          <Typography variant="subtitle2">{t('groups:managers')}</Typography>
        </Grid>

        <Grid item xs>
          <Grid container item xs={12}>
            <Moderators />
          </Grid>
        </Grid>
      </Grid>
    </PaddedPaper>
  );
};

export default GroupManagers;
